import { ACTIVE_COLOR, YELLOW_COLOR } from "@/constants/color";
import { Grid, Paper, Typography } from "@mui/material";
import { LogOut, Users, BookText, Gauge, Cog } from "lucide-react";
import { useAuth } from "@/context/auth-context";
import { useNavigate } from "react-router-dom";

export default function Page() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const options = [
    {
      key: "users",
      icon: <Users size={80} style={{ color: ACTIVE_COLOR }} />,
      title: "Usuarios",
      path: "/users",
      onClick: () => navigate("/users"),
    },
    {
      key: "reports",
      title: "Reportes",
      path: "/reports",
      onClick: () => navigate("/reports"),
      icon: <BookText size={80} style={{ color: ACTIVE_COLOR }} />,
    },
    {
      key: "ranking",
      title: "Ranking",
      path: "https://gruposinow.com/ranking/tablero.php",
      icon: <Gauge size={80} style={{ color: ACTIVE_COLOR }} />,
      redirect: true,
      onClick: () =>
        window.open("https://gruposinow.com/ranking/tablero.php", "_blank"),
    },
    {
      key: "control-panel",
      title: "Panel de control",
      path: "https://panel.gruposinow.com/",
      icon: <Cog size={80} style={{ color: ACTIVE_COLOR }} />,
      redirect: true,
      onClick: () => window.open("https://panel.gruposinow.com/", "_blank"),
    },
    {
      key: "logout",
      icon: <LogOut size={80} style={{ color: ACTIVE_COLOR }} />,
      title: "Cerrar Sesión",
      path: "/logout",
      onClick: () => logout(),
    },
  ];
  return (
    <Grid container spacing={4} sx={{ p: 2, mt: 5 }}>
      {options.map((option) => (
        <Grid
          key={option.key}
          size={{ xs: 6, lg: 4 }}
          sx={{
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <Paper
            elevation={3}
            sx={{ minHeight: 200, maxHeight: 200, alignContent: "center" }}
            onClick={option.onClick}
          >
            <Grid size={{ xs: 12 }}>{option.icon}</Grid>
            <Typography sx={{ color: ACTIVE_COLOR }}>{option.title}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
